import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4b1efe1a&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1efe1a",
  null
  
)

export default component.exports